module.exports = __webpack_public_path__ + "img/sponsored-by-intuit.e60d8df7.svg";